import IconLoader from '../public/images/loader.svg';

const LargeLoader = () => {
  return (
    <div className="loader-box">
      <IconLoader
        className="loader-box__loader__icon"
        aria-hidden="true"
      />
    </div>
  );
};

LargeLoader.displayName = 'LargeLoader';

export default LargeLoader;
